import { AxiosError } from 'axios'
import { ApiProvider } from '../provider'
import { APIRoutes } from '../routes'
import { TrainingItem } from 'api/types/trainings'

class Training {
  //get all trainings
  // traingingStatus values:
  // 0  -> past
  // 1  -> current and upcoming
  // 2  -> tutorials
  // 3  -> todos
  async getTrainingList({
    trainingStatus,
  }: {
    trainingStatus: '0' | '1' | '2' | '3'
  }): Promise<TrainingItem[] | (AxiosError | Error)> {
    let url = `${APIRoutes.trainings.getTrainingList}?trainingStatus=${trainingStatus}`

    return ApiProvider.getRequest(url) as Promise<
      TrainingItem[] | (AxiosError | Error)
    >
  }

  //get training by id
  async getTraining({
    id,
  }: {
    id: string
  }): Promise<TrainingItem | (AxiosError | Error)> {
    const url = `${APIRoutes.trainings.getTraining}?id=${id}`
    return ApiProvider.getRequest(url) as Promise<
      TrainingItem | (AxiosError | Error)
    >
  }

  // save training
  async saveTraining({
    trainingData,
  }: {
    trainingData: TrainingItem
  }): Promise<any | (AxiosError | Error)> {
    const url = `${APIRoutes.trainings.saveTraining}`
    const formData = new FormData()
    if (trainingData.id) {
      formData.append('id', String(trainingData.id))
    }
    formData.append('name', trainingData.name)
    formData.append('status', String(trainingData.status))
    if (trainingData.description) {
      formData.append('description', trainingData.description)
    }
    if (trainingData.content) {
      formData.append('content', trainingData.content)
    }
    if (trainingData.date) {
      formData.append('date', trainingData.date.replace('Z', ''))
    }
    if (trainingData.link) {
      formData.append('link', trainingData.link)
    }
    if (trainingData.conferenceId) {
      formData.append('conferenceId', trainingData.conferenceId)
    }
    if (trainingData.conferenceVideo) {
      formData.append('conferenceVideo', trainingData.conferenceVideo)
    }
    if (trainingData.teacher) {
      formData.append('teacher', trainingData.teacher)
    }
    if (trainingData.tutorial) {
      formData.append('tutorial', String(trainingData.tutorial))
    }
    if (trainingData.duration) {
      formData.append('duration', String(trainingData.duration))
    }

    return ApiProvider.postRequest(url, formData, true) as Promise<
      any | (AxiosError | Error)
    >
  }

  //delete training
  async deleteTraining({
    id,
  }: {
    id: string
  }): Promise<any | (AxiosError | Error)> {
    const url = `${APIRoutes.trainings.deleteTraining}?id=${id}`
    return ApiProvider.deleteRequest(url) as Promise<any | (AxiosError | Error)>
  }

  //register for training
  async registerForTraining({
    conferenceId,
    email,
    firstName,
    lastName,
  }: {
    conferenceId: string
    email: string
    firstName: string
    lastName: string
  }): Promise<any | (AxiosError | Error)> {
    const url = `${APIRoutes.trainings.registerForTraining}?conferenceId=${conferenceId}&email=${email}&firstName=${firstName}&lastName=${lastName}`
    return ApiProvider.postRequest(url, {}, false) as Promise<
      any | (AxiosError | Error)
    >
  }

  //get certificates
  async generateCertificate({
    email,
    conferenceId,
  }: {
    email: string
    conferenceId: string
  }): Promise<any | (AxiosError | Error)> {
    return ApiProvider.postRequest(
      APIRoutes.trainings.generateCertificate,
      {
        email,
        conferenceId,
      },
      false,
    ) as Promise<any | (AxiosError | Error)>
  }
}

export const trainingService = new Training()
